import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconOldPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75 1C5.16421 1 5.5 1.33579 5.5 1.75V3H19.25C19.6642 3 20 3.33579 20 3.75V17.25C20 19.8734 17.8734 22 15.25 22H8.75C6.12665 22 4 19.8734 4 17.25V1.75C4 1.33579 4.33579 1 4.75 1ZM8 7.75C8 7.33579 8.33579 7 8.75 7H15.25C15.6642 7 16 7.33579 16 7.75V13.25C16 13.6642 15.6642 14 15.25 14H8.75C8.33579 14 8 13.6642 8 13.25V7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldPhone;
